export default __webpack_public_path__ + "static/media/seo-cross-button.b738c644.svg";